import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup (props: any) {
    const newItems = props.items
    const last = newItems.pop()

    return () => {
      return (
        <div class="breadcrumbs">
          { newItems.map((item: any) => <span><a href={item.link }>{item.name}</a></span>) }
          {last ? (<span>{last.name}</span>) : null }
        </div>
      )
    }
  }
})